
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tyres/van/ford-transit-custom",
      function () {
        return require("private-next-pages/tyres/van/ford-transit-custom.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tyres/van/ford-transit-custom"])
      });
    }
  